module.exports = __webpack_public_path__ + "static/media/sf-test-12.2845cf1f.mp3";